module.exports = __webpack_public_path__ + "static/media/call.51818e8f.svg";